import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { MovementV2DataQuery, MovementV2DataQueryVariables } from './api.graphql';
import { MovementV2Data } from './api.graphql';

export type MovementV2PageData = {
	movement: NonNullable<MovementV2DataQuery['movement']>;
};

export async function getMovementV2PageData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
): Promise<MovementV2PageData> {
	const { data } = await fetch<MovementV2DataQuery, MovementV2DataQueryVariables>({
		query: MovementV2Data,
		variables: {
			slugOrId: slug,
		},
		rejectOnError: true,
	});

	if (!data.movement) {
		throw new NotFoundError();
	}

	return {
		movement: data.movement,
	};
}
